{
  "version": 1,
  "asset_id": "74f5b4a7-2547-492a-bbec-cd9391a56a80",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/74f5b4a7-2547-492a-bbec-cd9391a56a80/lecanto-metal-roof-after-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/74f5b4a7-2547-492a-bbec-cd9391a56a80/lecanto-metal-roof-after-768w.webp",
  "original_filename": "lecanto-metal-roof-after-768w.webp",
  "size": 103152,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:58Z"
}
